import axios from './request'
import config from '@/config'

const { baseURL } = config;

const getHeaders = () => {
  const userId = localStorage.getItem('userId') || '';
  return {
    userId,
  }
}

// 我的积分明细查询
export const queryOpinion = (params) => {
  let url = baseURL + 'h5/queryBug/query/PersonalOpinionDetail';
  const headers = getHeaders();
  return axios.post(url, params, { headers });
}

// 排行榜查询
export const queryRankList = (params) => {
  let url = baseURL + 'h5/queryBug/query/rankingList';
  const headers = getHeaders();
  return axios.post(url, params, { headers });
}


// WEBPACK FOOTER //
// ./src/api/pickFaultApi.js